import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Button } from 'reactstrap';
import { useIntl } from 'react-intl';

import G2ReviewButton from '../G2ReviewButton';

import { showModal } from '../../actions';

import { openIntercomNewMessage } from '../../helpers';
import { getTrialLeftDaysCount } from '../../helpers/App';
import { getWelcomeMessage } from '../../helpers/Dashboard';
import { getSetting } from '../../helpers/Settings';

const DashboardHeader = ({
  profile,
  openPersonalizeModal,
}) => {
  const userName = profile.name ? `${profile.name.split(' ')[0]}` : null;

  const daysLeftTrial = getTrialLeftDaysCount(profile.client);

  const [welcomeMessage] = useState(getWelcomeMessage(userName));

  const history = useHistory();
  const intl = useIntl();

  const handleHelpButton = () => {
    if (getSetting('cs1')) {
      history.push('/content/how-to');
    } else {
      openIntercomNewMessage();
    }
  };

  return (
    <header className="page-header dashboard-header">
      <div className="page-title">
        {getSetting('dashboard_messages') !== 'none' && (
          <h2 className="welcome-message">
            {(profile.is_first_login || getSetting('dashboard_messages') === 'welcome') ?
              intl.formatMessage({ defaultMessage: 'Welcome, {name}!' }, { name: userName }) :
              welcomeMessage}
          </h2>
        )}
        {daysLeftTrial && (
          <span className="dashboard-header-trial-notice">
            {intl.formatMessage({ defaultMessage: '{days} {days, plural, one {Day} other {Days}} left of trial' }, { days: daysLeftTrial })}
          </span>
        )}
        <div className="page-dashboard-title-actions" />
        <div className="dashboard-header-buttons">
          <G2ReviewButton />
          <Button
            color="link"
            onClick={() => openPersonalizeModal({
              className: 'personalize-dashboard-modal',
            })}
            size="sm"
          >
            <i className="far fa-sliders-up" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Personalize dashboard' })}
            </span>
          </Button>
          <Button
            color="link"
            size="sm"
            onClick={handleHelpButton}
          >
            <i className="far fa-circle-question" />
            <span>
              {intl.formatMessage({ defaultMessage: 'Help' })}
            </span>
          </Button>
        </div>
      </div>
    </header>
  );
};

const mapDispatchToProps = dispatch => ({
  openPersonalizeModal: (params) => {
    dispatch(showModal('DashboardPersonalizeModal', params));
  },
});

DashboardHeader.propTypes = {
  profile: PropTypes.object.isRequired,
  openPersonalizeModal: PropTypes.func.isRequired,
};

export default connect(null, mapDispatchToProps)(DashboardHeader);
